/**
 * Primary app navigation: single source for routes, access, and i18n label keys.
 * Add entries here when new top-level sections are introduced.
 */
import { ROUTES } from '@core/constants/routes.constants';

export type MainNavRoute = (typeof ROUTES)[keyof typeof ROUTES];

export interface MainNavItemConfig {
    route: MainNavRoute;
    /** i18n key in the `common` namespace (e.g. navigation.* or users.title) */
    labelKey: string;
    requiresAdmin?: boolean;
}

export const MAIN_NAV_ITEMS: readonly MainNavItemConfig[] = [
    { route: ROUTES.TEMPLATES, labelKey: 'navigation.ruleTemplates' },
    { route: ROUTES.REPORT_CATEGORY_CONFIG, labelKey: 'navigation.templateTypes' },
    { route: ROUTES.USERS, labelKey: 'users.title', requiresAdmin: true },
    { route: ROUTES.SYSTEM_PROMPT, labelKey: 'navigation.systemPrompt', requiresAdmin: true },
    { route: ROUTES.REFERENCE_LIST_CONFIGURATION, labelKey: 'navigation.referenceLists', requiresAdmin: true },
    { route: ROUTES.ZONES_CONFIGURATION, labelKey: 'navigation.zonesConfiguration', requiresAdmin: true },
] as const;
